<script setup lang="ts">
import { TIMEZONE_LOCALE, TIMEZONE_NAME_FORMAT, GMT_LABEL, DEFAULT_UTC_OFFSET, GMT_OFFSET_REGEX } from 'vince-core/constants/common';

type TimeZoneOption = {
    label: string;
    value: string;
};

const getUTCOffset = (timezone: string): string => {
    try {
        const date = new Date();
        const formatter = new Intl.DateTimeFormat(TIMEZONE_LOCALE, {
            timeZone: timezone,
            timeZoneName: TIMEZONE_NAME_FORMAT
        });
        const offsetStr = formatter.formatToParts(date).find(p => p.type === 'timeZoneName')?.value ?? GMT_LABEL;

        if (offsetStr === GMT_LABEL) { return DEFAULT_UTC_OFFSET; }

        const match = offsetStr.match(GMT_OFFSET_REGEX);
        if (match) {
            const sign = match[1];
            const hours = (match[2] ?? '0').padStart(2, '0');
            const minutes = (match[3] ?? '00').padStart(2, '0');
            return `UTC${sign}${hours}:${minutes}`;
        }
        return DEFAULT_UTC_OFFSET;
    } catch {
        return DEFAULT_UTC_OFFSET;
    }
};

const timeZoneOptions: TimeZoneOption[] = Intl.supportedValuesOf('timeZone').map((tz) => {
    const offset = getUTCOffset(tz);
    return { label: `(${offset}) ${tz}`, value: tz };
});

</script>

<template>
    <VLSelect
        :options="timeZoneOptions"
        option-label="label"
        option-value="value"
        filter
        v-bind="$attrs"
    />
</template>
